import { NgModule } from '@angular/core';
import { DocumentsComponent } from './documents.component';
import { DocumentsDetailsComponent } from './documents-details/documents-details.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { WindowlistModule } from 'projects/core/src/common/windowlist/windowlist.module';
import { PaginationModule } from 'projects/core/src/common/pagination/pagination.module';
import { DocumentsRoutingModule} from './documents-routing.module';
import { CitiesModule } from '../../modules/cities/cities.module';
import { ToolbarmodelModule } from 'projects/core/src/common/toolbarmodel/toolbarmodel.module';
import { DocumentlistComponent } from './documentlist/documentlist.component';
import { FilterdateModule } from '../../modules/filterdate/filterdate.module';
import { SearchproductModule } from '../../modules/searchproduct/searchproduct.module';
import { ComboboxModule } from 'projects/core/src/common/combobox/combobox.module';
import { SelectfieldcustomModule } from 'projects/core/src/common/selectfieldcustom/selectfieldcustom.module';
import { CashFlowModule } from '../cash-flow/cash-flow.module';
import { WindowModule } from 'projects/core/src/common/window/window.module';
import { ProductitemModule } from '../../modules/productitem/productitem.module';
import { StatedocumentModule } from '../../modules/statedocument/statedocument.module';
import { GoodsModule } from '../../modules/goods/goods.module';
import { SelecttemplateModule } from 'projects/core/src/common/selecttemplate/selecttemplate.module';
import { ReferenceModule } from '../../modules/reference/reference.module';
import { NationsModule } from 'projects/core/src/common/nations/nations.module';
import { CustomfieldsModule } from 'projects/core/src/common/customfields/customfields.module';
import { TransferComponent } from './transfer/transfer.component';
import { DeadlinesModule } from '../deadlines/deadlines.module';
import { DocumentssdiComponent } from './documentssdi/documentssdi.component';
import { FilesModule } from '../../modules/files/files.module';
import { OverviewComponent } from './overview/overview.component';
import { ReceiptModule } from '../../modules/receipt/receipt.module';
import { AllinvoicesComponent } from './allinvoices/allinvoices.component';
import { DocumentsTemplateComponent } from './documents-template/documents-template.component';
import { DocumentsTemplateDetailComponent } from './documents-template/documents-template-detail/documents-template-detail.component';
import { SelectTablesModule } from 'projects/core/src/common/tables/tables.module';
import { FinancialaccountModule } from '../../modules/financialaccount/financialaccount.module';
import { TaxCodeModule } from '../../modules/tax-code/tax-code.module';
import { VatNumberModule } from '../../modules/vat-number/vat-number.module';
//import { NgxTagsInputModule } from 'ngx-tags-input';
import { InventoryComponent } from './inventory/inventory.component';
import { DocumentinventoriesComponent } from './documentinventories/documentinventories.component';
import { TreecategoriesModule } from '../../modules/treecategories/treecategories.module';
import { Globals } from 'projects/core/src/globals';
import { SendinvoiceComponent } from './sendinvoice/sendinvoice.component';
import { FiltercontainerModule } from '../../modules/filtercontainer/filtercontainer.module';
import { FatturaelettronicaComponent, SafePipe } from './fatturaelettronica/fatturaelettronica.component';
import { WindowlistbuttonsModule } from 'projects/core/src/common/windowlistbuttons/windowlistbuttons.module';
import { DocumentsSettingsComponent } from './settings/settings.component';
import { SettingwindowComponent } from 'projects/core/src/common/settingwindow/settingwindow.component';
import { FieldsModule } from '../../modules/fields/fields.module';
import { ListpluginsComponent } from 'projects/core/src/common/settingwindow/listplugins/listplugins.component';
import { NotificationsModule } from 'projects/core/src/common/notifications/notifications.module';
import { types } from 'util';
import { TemplatePreviewModule } from '../../modules/template-preview/template-preview.module';


@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        NotificationsModule,
        CustomfieldsModule,
        WindowlistModule,
        WindowModule,
        DocumentsRoutingModule,
        PaginationModule,
        CitiesModule,
        ToolbarmodelModule,
        SearchproductModule,
        SelectfieldcustomModule,
        FilterdateModule,
        FiltercontainerModule,
        ComboboxModule,
        CashFlowModule,
        StatedocumentModule,
        ProductitemModule,
        GoodsModule,
        SelecttemplateModule,
        CashFlowModule,
        ReferenceModule,
        NationsModule,
        DeadlinesModule,
        FilesModule,
        ReceiptModule,
        SelectTablesModule,
        ReferenceModule,
        FinancialaccountModule,
        TaxCodeModule,
        VatNumberModule,
        //NgxTagsInputModule,
        TreecategoriesModule,
        WindowlistbuttonsModule,
        SettingwindowComponent,
        ListpluginsComponent,
        FieldsModule,
        TemplatePreviewModule

    ],
   exports: [DocumentsComponent,DocumentlistComponent,DocumentsDetailsComponent,DocumentinventoriesComponent,DocumentsSettingsComponent],
   declarations:  [DocumentsComponent,DocumentsDetailsComponent,DocumentlistComponent, TransferComponent, DocumentssdiComponent, OverviewComponent, AllinvoicesComponent, DocumentsTemplateComponent, DocumentsTemplateDetailComponent, InventoryComponent, DocumentinventoriesComponent, SendinvoiceComponent,SafePipe,FatturaelettronicaComponent,DocumentsSettingsComponent],
   providers: [],
})
export class DocumentsModule{ 

    static types=[
        {"id_type":1,"title":"Fattura","code":"FS","class":"badge bg-olive"},
        {"id_type":2,"title":"Fattura Accompagnatoria","code":"FV","class":"badge bg-teal"},
        {"id_type":12,"title":"Fattura Acconto","code":"FA","class":"badge bg-lime"},
        {"id_type":3,"title":"Nota di Credito","code":"NC","class":"badge bg-maroon"},
        {"id_type":14,"title":"Fattura proforma","code":"FP","class":"badge bg-orange"},
        {"id_type":4,"title":"Preventivo","code":"PR","class":"badge bg-warning"},
        {"id_type":5,"title":"Documento di trasporto","code":"DT","class":"badge bg-lightblue"},
        {"id_type":6,"title":"Scontrino","code":"SC","class":"badge bg-gray"},
        {"id_type":7,"title":"Ordine Cliente","code":"OC","class":"badge bg-secondary"},
        {"id_type":8,"title":"Ordine Fornitore","code":"OF","class":"badge bg-secondary"},
        {"id_type":9,"title":"Contabile non fiscale","code":"NF","class":"badge bg-secondary"},
        {"id_type":10,"title":"Trasferimento","code":"TR","class":"badge border"},
        {"id_type":11,"title":"Contabile fiscale","code":"FI","class":"badge border"},
        {"id_type":13,"title":"Inventario","code":"INV","class":"badge border"}
    ]


    constructor(){
        Globals.parameters.loadModulesEvent.subscribe((result)=>{
            
            Globals.permissions.addPermissionRule("documents","save","Salvataggio");
            Globals.permissions.addPermissionRule("documents","delete","Eliminazione");
            Globals.permissions.addPermissionRule("documents","showPaymentSchedule","Mostra scadenze pagamenti");
            Globals.permissions.addPermissionRule("documents","verifySdi","Accesso ai dati SDI");
            Globals.permissions.addPermissionRule("documents","showCreatedFrom","Mostra sedi");
            Globals.permissions.addPermissionRule("documents","showUsers","Modifica assegnazione utente");
            Globals.permissions.addPermissionRule("documents","editCausals","Modifica lista causali");
            Globals.permissions.addPermissionRule("documents","editInventories","Accesso al magazzino");
            Globals.permissions.addPermissionRule("documents","showAnalytics","Mostra statistiche");

             Globals.parameters.createParam(
                "documents",
                "autopreview",
                "Mostra anteprima di stampa documento",
                "boolean",
                null,
                false
            );

            Globals.parameters.createParam(
                "documents",
                "serverpreview_fastbutton",
                "Usa il server per creare la stampa su pulsante rapido",
                "boolean",
                null,
                true
            );

            
            Globals.parameters.createParam(
                "documents",
                "banks",
                "Banche",
                "table",
                [
                    {"name":"name","label":"Nome"},
                    {"name":"iban","label":"IBAN"},
                ]
            );


            Globals.parameters.createParam(
                "documents",
                "id_type_client",
                "ID Tipologia Clienti",
                "type"
            );

            Globals.parameters.createParam(
                "documents",
                "id_type_supplier",
                "ID Tipologia Fornitori",
                "type"
            );

            Globals.parameters.createParam(
                "documents",
                "id_type_deadline",
                "ID Tipologia Scadenza Pagamento Agenda",
                "type"
            );

            Globals.parameters.createParam(
                "documents",
                "id_shop_sdi_default",
                "ID esercizio di default per documenti in ingresso SdI (ID)",
                "number"
            );

            Globals.parameters.createParam(
                "documents",
                "default_causal_buy",
                "Causale di default documento in ingresso",
                "text"
            );

            Globals.parameters.createParam(
                "documents",
                "default_causal_sell",
                "Causale di default documento uscita",
                "text"
            );

            Globals.parameters.createParam(
                "documents",
                "causals",
                "Causali",
                "table",
                [
                    {"name":"description","label":"Causale"}
                ]
            );

            Globals.parameters.createParam(
                "documents",
                "aspect",
                "Aspetto",
                "table",
                [
                    {"name":"name","label":"Etichetta"}
                ]
            );

            Globals.parameters.createParam(
                "documents",
                "sectionals",
                "Sezionali",
                "table",
                [
                    {"name":"label","label":"Etichetta"},
                    {"name":"code","label":"Sezionale"}
                    
                ]
            );

            Globals.parameters.createParam(
                "documents",
                "referenceprefix",
                "Sezionale di default",
                "text"
            );
            
            Globals.parameters.createParam(
                "documents",
                "default_methodpayment",
                "Metodo di pagamento di default",
                "text"
            );            
            
            Globals.parameters.createParam(
                "documents",
                "default_bank",
                "Banca di default",
                "text"
            );

            Globals.parameters.createParam(
                "documents",
                "default_iban",
                "IBAN di default",
                "text"
            );

            Globals.parameters.createParam(
                "documents",
                "default_separator",
                "Separatore sezionale",
                "text"
            );

            Globals.parameters.createParam(
                "documents",
                "enablewelfarefund",
                "Abilita gestione cassa previdenziale",
                "boolean"
            );

            Globals.parameters.createParam(
                "documents",
                "percentualwelfarefund",
                "Percentuale cassa previdenziale",
                "number"
            );

            Globals.parameters.createParam(
                "documents",
                "percentualtaxwelfarefund",
                "Percentuale IVA cassa previdenziale",
                "number"
            );

            Globals.parameters.createParam(
                "documents",
                "typewelfarefund",
                "Codice Tipo Cassa (per fattura elettronica)",
                "text"
            );

            Globals.parameters.createParam(
                "documents",
                "percentualwithholdingtax",
                "Percentuale Ritenuta d'acconto di default",
                "number",
                "20"
            );

            Globals.parameters.createParam(
                "documents",
                "typewithholdingtax",
                "Codice tipo ritenuta (per fattura elettronica)",
                "text"
                
            );

            Globals.parameters.createParam(
                "documents",
                "filterdate",
                "Filtro data di default",
                "select",
                [
                    {"label":"Tutti","value":100},
                    {"label":"Ultimi 90 giorni","value":5},
                    {"label":"Ultimi 30 giorni","value":4},
                    {"label":"Ultimi 7 giorni","value":3},
                    {"label":"Oggi","value":1}
                ]
            );

            Globals.parameters.createParam(
                "documents",
                "envoicestylesheet",
                "Foglio di stile per fattura elettronica",
                "select",
                [
                    {"label":"Formato Ministeriale","value":1},
                    {"label":"Formato Assosoftware","value":2},
                ]
            );

            

        });
    }

    /**
     * Converte da ID Type Document alla struttura documento
     * @param id_type_document 
     * @returns 
     */
    static  TypeID2TypeDocument(id_type_document:number){

        for(let t of DocumentsModule.types){
            if(t.id_type==id_type_document)
                return t;
        }

        return {"id_type":0,"title":"","code":"","class":""}
                           
    }

}